(function () {
    'use strict';

    angular
        .module('app.shared')
        .directive('sc3AltSrc', sc3AltSrc);

    var OFI = 'bfred-it:object-fit-images',
        $ = angular.element,
        isDefined = angular.isDefined,
        isUndefined = angular.isUndefined,
        isEdgeOrIe = window.document.documentMode || /Edge\/\d./i.test(navigator.userAgent),
        NO_SRC = "//:0";

    sc3AltSrc.$inject = [];
    function sc3AltSrc() {
        return {
            restrict: 'A',
            link: link
        };

        function link(scope, element, attr) {
            var altSrc = attr.sc3AltSrc || NO_SRC;

            // Core
            attr.$observe('sc3AltSrc', sc3AltSrcWatchAction);
            element.on('error', error);

            // OFI Polyfill hookup
            element.on('load', load);
            scope.$on('$destroy', destroy);

            // src watchers
            if ('ngSrc' in attr)
                attr.$observe('ngSrc', ngSrcWatchAction);
            else
                attr.$observe('src', srcWatchAction);

            ////////////////////////////////////////

            // Core
            function sc3AltSrcWatchAction(newValue) {
                var oldValue = altSrc;
                altSrc = newValue || NO_SRC;
                if (attr.src === oldValue || isUndefined(attr.src))
                    setSrc(altSrc);
            }
            function error() {
                setSrc(altSrc);
            }
            function setSrc(value) {
                if (value && attr.src != value) {
                    attr.$set('src', value);
                    if (isEdgeOrIe && attr.src)
                        element.prop('src', attr.src);
                }
            }

            // OFI Polyfill hookup
            function load() {
                var ofi = element.prop(OFI);
                if (ofi && !ofi.errorHandlerAttached) {
                    $(ofi.img).on('error', error);
                    ofi.errorHandlerAttached = true;
                }
            }

            // src watchers
            function ngSrcWatchAction(value) {
                if (!value)
                    setSrc(altSrc);
            }
            function srcWatchAction(value) {
                if (!value)
                    setSrc(altSrc);
                else if (isEdgeOrIe)
                    element.prop('src', value);
            }

            // Destroy
            function destroy() {
                var ofi = element.prop(OFI);
                if (ofi && ofi.errorHandlerAttached)
                    $(ofi.img).off('error', error);
            }
        }
    }
})();
